/* =====================================================================
   Zipcode.js
   Standalone Shopify delivery-availability checker (no third-party app)
   ---------------------------------------------------------------------
   - Loads jQuery + Tingle modal if not present
   - Shows a "Check Delivery in Your Area" popup
   - Validates product/zipcode against your own rules (DA_SETTINGS below)
   - Blocks Add to Cart / Checkout when not deliverable
   - Stores the customer's last-checked zipcode in a cookie
   ===================================================================== */

(function () {
  "use strict";

  /* -------------------------------------------------------------------
   * 1. CONFIGURE YOUR RULES HERE
   * ------------------------------------------------------------------- */
  var DA_SETTINGS = {
    "applyFor": "specific",
    "allowDisallow": "allow",
    "zipcodes": "641005",
    "rules": [
      {
        "id": "1",
        "rule_name": "Chennai only Pincodes",
        "product_name": [
          { "value": "9888148816192", "label": "A2 Butter", "key": "9888148816192" },
          { "value": "9888147210560", "label": "Agathi Keerai", "key": "9888147210560" },
          { "value": "10109070573888", "label": "Alphonso Mango", "key": "10109070573888" },
          { "value": "9888147767616", "label": "Amla", "key": "9888147767616" },
          { "value": "9888147243328", "label": "Araikeerai", "key": "9888147243328" },
          { "value": "9888145146176", "label": "Avarakkai - Broad Beans", "key": "9888145146176" },
          { "value": "9888145178944", "label": "Baby Corn", "key": "9888145178944" },
          { "value": "9888145211712", "label": "Bajji Chilly", "key": "9888145211712" },
          { "value": "10016212320576", "label": "Banana Leaves for Pongal & Pooja| Fresh Vaazhai ilai | Jan 13 & 14 Delivery | Chennai Only", "key": "10016212320576" },
          { "value": "9888145244480", "label": "Bangalore Tomato", "key": "9888145244480" },
          { "value": "9888145277248", "label": "Beans", "key": "9888145277248" },
          { "value": "9888145310016", "label": "Beetroot", "key": "9888145310016" },
          { "value": "9888145342784", "label": "Big Onion", "key": "9888145342784" },
          { "value": "9888145375552", "label": "Bitter Gourd - Long", "key": "9888145375552" },
          { "value": "9888145408320", "label": "Bitter Gourd - Small", "key": "9888145408320" },
          { "value": "9888145441088", "label": "Bottle Gourd - Sorakkai", "key": "9888145441088" },
          { "value": "9888145473856", "label": "Brinjal - Green", "key": "9888145473856" },
          { "value": "10124830540096", "label": "Brinjal - Green", "key": "10124830540096" },
          { "value": "9888145506624", "label": "Brinjal - Violet", "key": "9888145506624" },
          { "value": "9888145539392", "label": "Brinjal - White", "key": "9888145539392" },
          { "value": "9888145572160", "label": "Broccoli", "key": "9888145572160" },
          { "value": "9888145604928", "label": "Butter Beans (With Skin)", "key": "9888145604928" },
          { "value": "9888145637696", "label": "Cabbage", "key": "9888145637696" },
          { "value": "9888145670464", "label": "Capsicum - Green", "key": "9888145670464" },
          { "value": "9886950981952", "label": "Carrot", "key": "9886950981952" },
          { "value": "9888145703232", "label": "Cauliflower", "key": "9888145703232" },
          { "value": "9888145736000", "label": "Chow Chow", "key": "9888145736000" },
          { "value": "9888145768768", "label": "Coconut", "key": "9888145768768" },
          { "value": "9888147276096", "label": "Coriander", "key": "9888147276096" },
          { "value": "9888145801536", "label": "Cucumber - Country", "key": "9888145801536" },
          { "value": "9888145834304", "label": "Cucumber - English", "key": "9888145834304" },
          { "value": "9888147308864", "label": "Curry Leaves", "key": "9888147308864" },
          { "value": "9888145867072", "label": "Elephant Yam", "key": "9888145867072" },
          { "value": "10138126975296", "label": "Flat Beans", "key": "10138126975296" },
          { "value": "9888145899840", "label": "Garlic - Small", "key": "9888145899840" },
          { "value": "9888145932608", "label": "Ginger", "key": "9888145932608" },
          { "value": "9888145965376", "label": "Green Chilly", "key": "9888145965376" },
          { "value": "10130884165952", "label": "Green Ponnangani", "key": "10130884165952" },
          { "value": "9888145998144", "label": "Green Tomato - Thakkali Kai", "key": "9888145998144" },
          { "value": "10084056727872", "label": "Groundnuts with Shell", "key": "10084056727872" },
          { "value": "9888146030912", "label": "Hill Garlic", "key": "9888146030912" },
          { "value": "9888146063680", "label": "Kaaramani - Long Beans", "key": "9888146063680" },
          { "value": "9888146096448", "label": "Knol Khol", "key": "9888146096448" },
          { "value": "9888146129216", "label": "Kothavarai - Cluster Beans", "key": "9888146129216" },
          { "value": "9888146161984", "label": "Kovakkai - Ivy Gourd", "key": "9888146161984" },
          { "value": "9888146194752", "label": "Ladiesfinger", "key": "9888146194752" },
          { "value": "9888146227520", "label": "Maa Inji - Mango Ginger", "key": "9888146227520" },
          { "value": "9888147341632", "label": "Manathakkali Keerai", "key": "9888147341632" },
          { "value": "10005049246016", "label": "Manathakkali Keerai", "key": "10005049246016" },
          { "value": "10016403554624", "label": "Mango Leaves for Pongal & Pooja| Fresh Maa ilai | Jan 13 & 14 Delivery | Chennai Only", "key": "10016403554624" },
          { "value": "9888146260288", "label": "Maravallikilangu - Tapioca", "key": "9888146260288" },
          { "value": "10115210871104", "label": "Marudhani - Henna Leaves", "key": "10115210871104" },
          { "value": "9888147374400", "label": "Methi - Venthaya Keerai", "key": "9888147374400" },
          { "value": "9888147407168", "label": "Mudakathan", "key": "9888147407168" },
          { "value": "9888146293056", "label": "Mudavaatukaal Kizhangu", "key": "9888146293056" },
          { "value": "9888147439936", "label": "Mulaikeerai", "key": "9888147439936" },
          { "value": "10002148655424", "label": "Murungai Keerai (Drumstick Leaves)", "key": "10002148655424" },
          { "value": "9888146325824", "label": "Murungaikai - Drumstick", "key": "9888146325824" },
          { "value": "9888146358592", "label": "Naatu Tomato", "key": "9888146358592" },
          { "value": "9888146391360", "label": "Ooty Potato", "key": "9888146391360" },
          { "value": "10016203276608", "label": "Organic Turmeric Plant for Pongal | Fresh Manjal Kothu | Jan 13 & 14 Delivery | Chennai Only", "key": "10016203276608" },
          { "value": "9888147472704", "label": "Palak", "key": "9888147472704" },
          { "value": "10024867168576", "label": "Paruppu Keerai", "key": "10024867168576" },
          { "value": "9888146424128", "label": "Pattani - Green Peas", "key": "9888146424128" },
          { "value": "9888147505472", "label": "Pirandai Stem", "key": "9888147505472" },
          { "value": "9888146456896", "label": "Podalangai - Snake Gourd (Long)", "key": "9888146456896" },
          { "value": "9888146489664", "label": "Podalangai - Snake Gourd (Small)", "key": "9888146489664" },
          { "value": "9888146522432", "label": "Potato", "key": "9888146522432" },
          { "value": "9888147538240", "label": "Pulicha Keerai - Gongura Leaves", "key": "9888147538240" },
          { "value": "9888147571008", "label": "Puthina", "key": "9888147571008" },
          { "value": "10002168021312", "label": "Radish (Red)", "key": "10002168021312" },
          { "value": "9888146555200", "label": "Radish (White)", "key": "9888146555200" },
          { "value": "10002230903104", "label": "Raw Mango", "key": "10002230903104" },
          { "value": "9888146587968", "label": "Raw Papaya", "key": "9888146587968" },
          { "value": "9888146620736", "label": "Raw Turmeric", "key": "9888146620736" },
          { "value": "9888146653504", "label": "Red Cabbage", "key": "9888146653504" },
          { "value": "9888146686272", "label": "Red Kaaramani - Long Beans Red", "key": "9888146686272" },
          { "value": "9888147603776", "label": "Red Ponnanganni", "key": "9888147603776" },
          { "value": "9888147636544", "label": "Red Thandukeerai", "key": "9888147636544" },
          { "value": "9888146719040", "label": "Ridge Gourd - Peerkankai", "key": "9888146719040" },
          { "value": "9888146751808", "label": "Sambar Cucumber - Malabar", "key": "9888146751808" },
          { "value": "9888146817344", "label": "Seppakizhangu - Arbi", "key": "9888146817344" },
          { "value": "9888147669312", "label": "Sirukeerai", "key": "9888147669312" },
          { "value": "9888146850112", "label": "Small Onion", "key": "9888146850112" },
          { "value": "9888147702080", "label": "Spring Onion", "key": "9888147702080" },
          { "value": "9888146882880", "label": "Sweet Corn", "key": "9888146882880" },
          { "value": "9888146915648", "label": "Sweet Potato", "key": "9888146915648" },
          { "value": "9888146948416", "label": "Thambatai Avarakkai - Sword Beans", "key": "9888146948416" },
          { "value": "10024862449984", "label": "Thippili Leaves", "key": "10024862449984" },
          { "value": "10115212149056", "label": "Thoothuvalai", "key": "10115212149056" },
          { "value": "9888147734848", "label": "Vallarai", "key": "9888147734848" },
          { "value": "9888146981184", "label": "Vazhaipoo - Banana Flower", "key": "9888146981184" },
          { "value": "9888147013952", "label": "Vazhaithandu - Banana Stem", "key": "9888147013952" },
          { "value": "9888147046720", "label": "Vazhakaai - Banana Raw", "key": "9888147046720" },
          { "value": "9888147079488", "label": "White Pumpkin", "key": "9888147079488" },
          { "value": "9888147112256", "label": "Yellow Pumpkin", "key": "9888147112256" },
          { "value": "9888147145024", "label": "Zucchini - Green", "key": "9888147145024" },
          { "value": "9888147177792", "label": "Zucchini - Yellow", "key": "9888147177792" },
          { "value": "9888147800384", "label": "Aranellikaai", "key": "9888147800384" },
          { "value": "9888147833152", "label": "Avocado", "key": "9888147833152" },
          { "value": "10107306967360", "label": "Banganapalli Mango", "key": "10107306967360" },
          { "value": "9888147865920", "label": "Custard Apple - Sitaphal", "key": "9888147865920" },
          { "value": "9888147931456", "label": "Guava", "key": "9888147931456" },
          { "value": "9888147964224", "label": "Hill Banana", "key": "9888147964224" },
          { "value": "10109069852992", "label": "Imam Pasand Mango", "key": "10109069852992" },
          { "value": "9888147996992", "label": "Karpooravalli Banana", "key": "9888147996992" },
          { "value": "10125831602496", "label": "Kesar Mango", "key": "10125831602496" },
          { "value": "9888148029760", "label": "Kinnaur Red Apple", "key": "9888148029760" },
          { "value": "9994660282688", "label": "Kinnow Orange", "key": "9994660282688" },
          { "value": "9888148062528", "label": "Lemon", "key": "9888148062528" },
          { "value": "9888148095296", "label": "Muskmelon", "key": "9888148095296" },
          { "value": "9888148128064", "label": "Nagpur Orange", "key": "9888148128064" },
          { "value": "10024670822720", "label": "Narthangai", "key": "10024670822720" },
          { "value": "10024666333504", "label": "Nendram Banana", "key": "10024666333504" },
          { "value": "10061910376768", "label": "Organic Black Paneer Grapes| Seeded | Chemical-Free Seasonal Fruit | Farm Fresh", "key": "10061910376768" },
          { "value": "10016194756928", "label": "Organic Full Sugarcane for Pongal | Farm Fresh Produce | Jan 13 & 14 Delivery | Chennai Only", "key": "10016194756928" },
          { "value": "9888147898688", "label": "Organic Green Grapes – Seedless", "key": "9888147898688" },
          { "value": "10016688505152", "label": "Organic Seedless Black Grapes | Chemical-Free Seasonal Fruit |", "key": "10016688505152" },
          { "value": "10143173214528", "label": "Panchavarnam Mango", "key": "10143173214528" },
          { "value": "9888148226368", "label": "Papaya", "key": "9888148226368" },
          { "value": "9888148259136", "label": "Pineapple", "key": "9888148259136" },
          { "value": "9886952128832", "label": "Pomegranate", "key": "9886952128832" },
          { "value": "9888148291904", "label": "Poovan Banana", "key": "9888148291904" },
          { "value": "9888148324672", "label": "Rasthali Banana", "key": "9888148324672" },
          { "value": "9888148357440", "label": "Red Banana", "key": "9888148357440" },
          { "value": "9888148390208", "label": "Red Dragon Fruit", "key": "9888148390208" },
          { "value": "10135419683136", "label": "Rumani Mango", "key": "10135419683136" },
          { "value": "9888148422976", "label": "Sapota", "key": "9888148422976" },
          { "value": "10115135832384", "label": "Senthuram Mango", "key": "10115135832384" },
          { "value": "9888148455744", "label": "Shimla Red Apple", "key": "9888148455744" },
          { "value": "9888148488512", "label": "Strawberry", "key": "9888148488512" },
          { "value": "9981963174208", "label": "Sugarcane", "key": "9981963174208" },
          { "value": "9888148521280", "label": "Sweet Lime", "key": "9888148521280" },
          { "value": "9888148554048", "label": "Sweet Passion Fruit", "key": "9888148554048" },
          { "value": "9888148586816", "label": "Tender Coconut", "key": "9888148586816" },
          { "value": "10130855330112", "label": "Water Apple", "key": "10130855330112" },
          { "value": "9888148619584", "label": "Watermelon - Country", "key": "9888148619584" },
          { "value": "9888148652352", "label": "Watermelon - Kiran Dark Green", "key": "9888148652352" },
          { "value": "9888148685120", "label": "Yelakki Banana", "key": "9888148685120" },
          { "value": "10014068867392", "label": "Kutti Pongal Combo – Traditional Pongal Ingredients Kit | Jan 13 & 14 Delivery | Chennai Only", "key": "10014068867392" },
          { "value": "10014068998464", "label": "Jumbo Pongal Combo – Traditional Pongal Ingredients Kit | Jan 13 & 14 Delivery | Chennai Only", "key": "10014068998464" },
          { "value": "10005055832384", "label": "Motchai", "key": "10005055832384" },
          { "value": "9888153469248", "label": "Naatukozhi Eggs", "key": "9888153469248" },
          { "value": "10183040565568", "label": "Rambutan", "key": "10183040565568" },
          { "value": "10161275470144", "label": "Pears", "key": "10161275470144" },
          { "value": "10225659412800", "label": "Shimla Apples | Gala Small", "key": "10225659412800" },
          { "value": "10225265312064", "label": "Capsicum - Yellow", "key": "10225265312064" },
          { "value": "10247498039616", "label": "Royal Apple", "key": "10247498039616" },
          { "value": "10249351921984", "label": "Palagaram Combo | Krishna Janmashtami Special", "key": "10249351921984" },
          { "value": "10249372074304", "label": "Mini Combo | Krishna Janmashtami Special", "key": "10249372074304" },
          { "value": "10249378038080", "label": "Mega Combo | Krishna Janmashtami Special", "key": "10249378038080" },
          { "value": "10231925571904", "label": "Kalyana Murungai", "key": "10231925571904" },
          { "value": "10255119515968", "label": "Pooja Combo | Vinayagar Chaturthi Special", "key": "10255119515968" },
          { "value": "10255120531776", "label": "Delight Combo | Vinayagar Chaturthi Special", "key": "10255120531776" },
          { "value": "10260393460032", "label": "Ganesha's Decor | Vinayagar Chaturthi Special", "key": "10260393460032" },
          
        ],
        "productzipcode": "600001, 600002, 600003, 600004, 600005, 600006, 600007, 600008, 600009, 600010, 600011, 600012, 600013, 600014, 600015, 600016, 600017, 600018, 600020, 600021, 600022, 600023, 600024, 600025, 600026, 600028, 600030, 600031, 600032, 600033, 600034, 600035, 600036, 600038, 600039, 600040, 600041, 600042, 600043, 600044, 600045, 600046, 600047, 600048, 600056, 600059, 600114, 600062, 600063, 600064, 600070, 600073, 600075, 600078, 600081, 600082, 600083, 600084, 600085, 600086, 600088, 600089, 600090, 600091, 600092, 600093, 600094, 600096, 600097, 600099, 600100, 600101, 600102, 600104, 600106, 600107, 600100, 600110, 600113, 600115, 600116, 600117, 600118, 600119, 600056, 600125, 600127, 600128, 600129, 600126, 600044, 600130, 603102, 603103, 603108, 600125, 600028, 603202, 600056, 603209, 603210, 603202, 600099, 603112, 600100, 600078, 600116, 600091, 600127, 600116, 600127, 603302, 603302, 600087, 600083, 603103, 600131, 600100, 600048, 600048, 600004, 600018, 600028, 600005, 600041, 600041, 600056, 600077, 600077, 600015, 600060, 600112, 600019, 600001, 600001, 600019, 600125, 600125, 600116, 600122, 600069, 600095, 600037, 600107, 600058, 600053, 600072, 600062, 600062, 600095, 600095, 600073, 600126, 600048, 600048, 600091, 600119, 600119, 600096, 603103, 603103, 603103, 603103, 600048, 600045, 601103, 600043, 600028, 600003, 601301, 600060, 600127, 600035, 600056, 600049, 600050, 600006, 600126, 600126, 600016, 600048, 600126, 600028, 600086, 600028, 600004, 600056, 600077, 600084, 600010, 600011, 600122, 600116, 600044, 600037, 600037, 600095, 600012, 600064, 600126, 600073, 600073, 600074, 600061, 600016, 600117, 600115, 600097, 600119, 603103, 603112, 600126, 600077,600076,600029,600027, 600037, 600049, 600050, 600051, 600053, 600054, 600055,600080, 603211,600071, 603001, 603002, 603204, 602024",
        "allowDisallowProduct": "allow"
      }
    ]
  };

  /* -------------------------------------------------------------------
   * 2. SCRIPT LOADER HELPER
   * ------------------------------------------------------------------- */
  function daLoadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  if (!window.jQuery) {
    daLoadScript("https://code.jquery.com/jquery-3.6.0.min.js", function () {
      daInit();
    });
  } else {
    daInit();
  }

  function daInit() {
    var isHeaderDACheck = false;
    var pendingDAAction = null;
    var daBypassGuard = false;

    function trimAndCase(str) {
      return String(str).replace(/\s/g, "").toLowerCase();
    }

    function escapeRegExp(str) {
      return str.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
    }

    function replaceAll(str, find, replace) {
      return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
    }

    function isZipInList(zipcode, zipListStr) {
      var target = trimAndCase(zipcode);
      var list = zipListStr.split(",");
      for (var i = 0; i < list.length; i++) {
        var candidate = trimAndCase(list[i]);
        if (!candidate) continue;
        if (target.length === candidate.length) {
          if (target.startsWith(replaceAll(candidate, "*", ""))) {
            return true;
          }
        }
      }
      return false;
    }

    function isAllowed(allowDisallow, zipListStr, zipcode) {
      var found = isZipInList(zipcode, zipListStr);
      return allowDisallow === "allow" ? found : !found;
    }

    /* -----------------------------------------------------------------
     * GLOBAL GUARD — single source of truth for "can this product be
     * added / updated in the cart right now". Used by zipcode.js's own
     * delegated click handler AND directly by card.js before it fires
     * any add/increment AJAX call.
     *
     * Returns true immediately if allowed (caller proceeds as normal).
     * Returns false if blocked: opens the popup and stores `onAllowed`
     * as the action to resume once the customer confirms a valid,
     * deliverable pincode (or does nothing if never confirmed).
     * ----------------------------------------------------------------- */
    function daGuard(productId, onAllowed) {
      var zip = daGetCookie("da_lastzipcode");

      if (zip === "") {
        pendingDAAction = { checkId: productId, resume: onAllowed };
        if (modal) modal.open();
        return false;
      }

      if (!checkDeliveryAvailability(DA_SETTINGS, productId, zip)) {
        pendingDAAction = null;
        daRenderResult(false, zip);
        if (modal) modal.open();
        return false;
      }

      return true;
    }

    function isAllowedFromRules(rules, productId, zipcode) {
      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        for (var j = 0; j < rule.product_name.length; j++) {
          if (rule.product_name[j].value == productId) {
            return isAllowed(rule.allowDisallowProduct, rule.productzipcode, zipcode);
          }
        }
      }
      return true;
    }

    function checkDeliveryAvailability(settings, productId, zipcode) {
      if (!settings || !zipcode) return true;
      if (settings.applyFor === "specific") {
        if (productId != null && productId !== "" && settings.rules && settings.rules.length > 0) {
          if (!isAllowedFromRules(settings.rules, productId, zipcode)) {
            return false;
          }
        }
        return true;
      } else {
        return isAllowed(settings.allowDisallow, settings.zipcodes, zipcode);
      }
    }

    if (!String.prototype.startsWith) {
      Object.defineProperty(String.prototype, "startsWith", {
        value: function (search, rawPos) {
          var pos = rawPos > 0 ? rawPos | 0 : 0;
          return this.substring(pos, pos + search.length) === search;
        }
      });
    }

    function daSetCookie(cname, cvalue) {
      var expires = "expires=Sun, 06 Oct 2030 05:50:39 GMT";
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function daSetOneTimeCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";path=/";
    }
    function daGetCookie(cname) {
      var name = cname + "=";
      var decoded = decodeURIComponent(document.cookie);
      var ca = decoded.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
      }
      return "";
    }

    function getDAProdId() {
      if (typeof daProdId !== "undefined") return daProdId;
      if (typeof ShopifyAnalytics !== "undefined" && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        return ShopifyAnalytics.meta.product.id;
      }
      return null;
    }

    function isSpecificSelectedAndShowPopup() {
      if (DA_SETTINGS.applyFor === "specific") {
        return getDAProdId() == null;
      }
      return false;
    }

    var svgString =
      '<svg style="cursor:pointer;width:30px;" viewBox="0 0 100.353 100.352" xmlns="http://www.w3.org/2000/svg"><g><path d="M58.23,69.992l14.993-24.108c0.049-0.078,0.09-0.16,0.122-0.245c2.589-4.222,3.956-9.045,3.956-13.969c0-14.772-12.018-26.79-26.79-26.79S23.72,16.898,23.72,31.67c0,4.925,1.369,9.75,3.96,13.975c0.03,0.074,0.065,0.146,0.107,0.216l14.455,24.191c-11.221,1.586-18.6,6.2-18.6,11.797c0,6.935,11.785,12.366,26.829,12.366S77.3,88.783,77.3,81.849C77.301,76.226,69.578,71.509,58.23,69.992z M30.373,44.294c-2.39-3.804-3.653-8.169-3.653-12.624c0-13.118,10.672-23.79,23.791-23.79c13.118,0,23.79,10.672,23.79,23.79c0,4.457-1.263,8.822-3.652,12.624c-0.05,0.08-0.091,0.163-0.124,0.249L54.685,70.01c-0.238,0.365-0.285,0.448-0.576,0.926l-4,6.432L30.507,44.564C30.472,44.471,30.427,44.38,30.373,44.294z M50.472,91.215c-14.043,0-23.829-4.937-23.829-9.366c0-4.02,7.37-7.808,17.283-8.981l4.87,8.151c0.269,0.449,0.751,0.726,1.274,0.73c0.004,0,0.009,0,0.013,0c0.518,0,1-0.268,1.274-0.708l5.12-8.232C66.548,73.9,74.3,77.784,74.3,81.849C74.301,86.279,64.515,91.215,50.472,91.215z"></path><path d="M60.213,31.67c0-5.371-4.37-9.741-9.741-9.741s-9.741,4.37-9.741,9.741s4.37,9.741,9.741,9.741C55.843,41.411,60.213,37.041,60.213,31.67z M43.731,31.67c0-3.717,3.024-6.741,6.741-6.741s6.741,3.024,6.741,6.741s-3.023,6.741-6.741,6.741S43.731,35.387,43.731,31.67z"></path></g></svg>';

    var zipcode = daGetCookie("da_lastzipcode") || "";
    var $svgContainer = jQuery(
      '<div id="da-check" class="svg-container" style="display:flex; align-items:center;cursor:pointer;"></div>'
    );
    $svgContainer.append(svgString);
    $svgContainer.append('<span class="da-zipcode-info">' + zipcode + "</span>");

    if (jQuery(".cart-drawer-button").length) {
      jQuery(".cart-drawer-button").before($svgContainer);
    } else {
      jQuery("body").append($svgContainer);
    }

    jQuery("head").append(
      "<style>" +
      ".svg-container .da-zipcode-info{font-size:13px;font-weight:600;color:#2e2e2e;font-family:Arial,Helvetica,sans-serif;white-space:nowrap;}" +
      ".tingle-modal.da-cls-1{z-index:99999 !important;background-color:rgba(15,15,15,.55) !important;backdrop-filter:blur(2px);}" +
      ".tingle-modal.da-cls-1 .tingle-modal-box{border-radius:16px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.25);max-width:420px;animation:daPopIn .25s ease-out;}" +
      "@keyframes daPopIn{from{opacity:0;transform:translateY(10px) scale(.98);}to{opacity:1;transform:translateY(0) scale(1);}}" +
      ".tingle-modal .tingle-modal-close{background:#f4f4f4;border-radius:50%;width:32px;height:32px;top:14px;right:14px;box-shadow:none;}" +
      ".tingle-modal .tingle-modal-close svg{width:14px;height:14px;}" +
      ".da_popup{text-align:center;padding:32px 28px 28px;font-family:Arial,Helvetica,sans-serif;}" +
      ".da_h1{font-weight:700;font-size:22px;line-height:1.3;margin:0 0 6px;color:#111;}" +
      ".da_sub{font-size:14px;color:#767676;margin:0 0 20px;}" +
      ".da_popup_img{max-width:130px;display:block;margin:0 auto 18px;}" +
      ".da_field{position:relative;max-width:340px;margin:0 auto 14px;}" +
      ".da_popup input[type=text]{appearance:none;display:block;width:100%;padding:13px 14px;line-height:20px;font-size:15px;background:#fafafa;border-radius:10px;border:1.5px solid #e2e2e2;text-align:left;transition:border-color .15s ease,background .15s ease;outline:none;}" +
      ".da_popup input[type=text]::placeholder{color:#a3a3a3;}" +
      ".da_popup input[type=text]:focus{border-color:#4caf50;background:#fff;box-shadow:0 0 0 3px rgba(76,175,80,.12);}" +
      ".da_popup input[type=text].da-input-error{border-color:#e14b3f;background:#fff6f5;}" +
      ".da_btn{position:relative;display:inline-flex;align-items:center;justify-content:center;gap:8px;height:46px;padding:0 24px;width:100%;max-width:340px;background:0 0;overflow:hidden;appearance:none;transition:all .15s ease-out;font-size:14px;font-weight:700;line-height:1;letter-spacing:.4px;text-decoration:none;text-transform:uppercase;white-space:nowrap;border-radius:10px;border-style:solid;border-width:1.5px;font-family:Arial,Helvetica,sans-serif;cursor:pointer;}" +
      ".da_btn:hover{opacity:.9;transform:translateY(-1px);}" +
      ".da_btn:active{transform:translateY(0);}" +
      ".da_btn:disabled{opacity:.6;cursor:not-allowed;transform:none;}" +
      ".da_btn-primary-outlined{background-color:#111;color:#fff;border-color:#111;}" +
      ".da_btn-primary-outlined:hover{background-color:#000;}" +
      ".da_btn-secondary{background-color:#fff;color:#111;border-color:#dcdcdc;}" +
      ".da_btn-secondary:hover{background-color:#f7f7f7;border-color:#c8c8c8;}" +
      ".da_btn-success{background-color:#fff;color:#6E9C1C;border-color:#6E9C1C;}" +
      ".da_btn-success:hover{background-color:#FBFFEE;}" +
      ".da_btn-danger{background-color:#fff;color:#E53935;border-color:#E53935;}" +
      ".da_btn-danger:hover{background-color:#fdeceb;}" +
      ".da_btn .da-spinner{width:15px;height:15px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:daSpin .6s linear infinite;display:none;}" +
      ".da_btn.is-loading .da-spinner{display:inline-block;}" +
      ".da_btn.is-loading .btn__label{opacity:.7;}" +
      "@keyframes daSpin{to{transform:rotate(360deg);}}" +
      "#da-error-msg{color:#e14b3f;margin:6px 0 4px;font-size:13px;font-weight:600;min-height:16px;text-align:left;max-width:340px;margin-left:auto;margin-right:auto;}" +
      "#da-available,#da-noavailable{display:none;font-size:15px;line-height:1.5;font-family:Arial,Helvetica,sans-serif;color:#333;}" +
      ".da-result-icon{width:52px;height:52px;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 14px;}" +
      "#da-available .da-result-icon{background:#e8f6ea;}" +
      "#da-noavailable .da-result-icon{background:#fdeceb;}" +
      "#da-available .da-result-icon svg{width:24px;height:24px;}" +
      "#da-noavailable .da-result-icon svg{width:24px;height:24px;}" +
      ".da-result-title{font-size:18px;font-weight:700;color:#111;margin-bottom:6px;}" +
      ".zincode_cookie{font-weight:700;margin:10px 0 20px;color:#111;background:#f4f4f4;display:inline-block;padding:6px 14px;border-radius:20px;font-size:13px;}" +
      "#da-available .da_btn,#da-noavailable .da_btn{margin-top:6px;}" +
      "#da-noavailable p{color:#e14b3f;font-weight:600;}" +
      ".da_diff_check{color:#111;display:none;margin-top:16px;font-size:13px;font-weight:600;text-decoration:underline;text-underline-offset:2px;cursor:pointer;}" +
      ".da_diff_check:hover{color:#4caf50;}" +
      ".tingle-modal *{vertical-align:middle;box-sizing:border-box;}" +
      '@media (max-width: 480px) {' +
      '.da_popup { max-width: 90vw; padding: 28px 20px 22px; border-radius: 18px; }' +
      '.da_popup_img { width: 104px; margin-bottom: 18px; }' +
      '.da_h1 { font-size: 18px; }' +
      '.da_scroll { padding: 16px 12px; }' +
      '}' +
      "</style>"
    );

    jQuery("head").append(
      '<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/tingle/0.15.1/tingle.min.css">'
    );

    var modal = null;
    var isCheckoutAllowed = true;

    daLoadScript("https://cdnjs.cloudflare.com/ajax/libs/tingle/0.15.1/tingle.min.js", function () {
      modal = new tingle.modal({
        footer: false,
        closeMethods: ["overlay", "button", "escape"],
        closeLabel: "Close",
        cssClass: ["da-cls-1", "da-cls-2"],
        onOpen: function () {
          jQuery("#da-check").hide();
        },
        onClose: function () {
          daSetOneTimeCookie("da_popupclosed", "s");
          jQuery("#da-check").show();
          pendingDAAction = null;
        }
      });

      var scooterImg =
        '<img class="da_popup_img" src="https://drpo5mjxhw4s.cloudfront.net/media/sac/popup/10.svg?v1" alt="Delivery" />';

      modal.setContent(
        '<div class="da_popup">' +

        '<h1 class="da_h1">Check Delivery in Your Area</h1>' +
        '<p class="da_sub">We currently serve select locations</p>' +

        scooterImg +

        '<div class="da_checker">' +

        '<div class="da_field">' +
        '<input type="text" placeholder="Enter your Pin code" id="da_zincode" name="da_zincode" inputmode="numeric" />' +
        '</div>' +

        '<div id="da-error-msg"></div>' +

        '<button id="da_check_zincode" class="da_btn da_btn-primary-outlined">' +
        '<span class="da-spinner"></span>' +
        '<span class="btn__label">Check Availability</span>' +
        '</button>' +

        '</div>' +

        // Available Result
        '<div id="da-available" style="display:none;">' +
        '<div class="da-result-title">Great news!</div>' +
        '<p>We currently serve your area.</p>' +
        '<div><span class="zincode_cookie"></span></div>' +
        '<button id="da_pop_close" class="da_btn da_btn-success">CONTINUE SHOPPING</button>' +
        '</div>' +

        // Not Available Result
        '<div id="da-noavailable" style="display:none;">' +
        '<div class="da-result-title">Limited delivery</div>' +
        '<p styple="text-colore">We can only deliver limited items to your location (Fruits &amp; Vegetables not deliverable to your area)</p>' +
        '<div><span class="zincode_cookie"></span></div>' +
        '<button id="da_pop_close_unavailable" class="da_btn da_btn-danger">CLOSE</button>' +
        '</div>' +

        // Change Pincode
        '<a class="da_diff_check" href="#" style="display:none;">Change Pin code</a>' +

        '</div>'
      );
      // initial check on page load
      if (daGetCookie("da_lastzipcode") === "") {
        if (daGetCookie("da_popupclosed") !== "s" && !isSpecificSelectedAndShowPopup()) {
          modal.open();
        }
      } else {
        if (!checkDeliveryAvailability(DA_SETTINGS, getDAProdId(), daGetCookie("da_lastzipcode"))) {
          daRenderResult(false, daGetCookie("da_lastzipcode"));
          if (daGetCookie("da_popupclosed") !== "s" && !isSpecificSelectedAndShowPopup()) {
            modal.open();
          }
        }
      }

      // header icon click -> open popup manually
      jQuery("body").on("click", "#da-check", function (e) {
        isHeaderDACheck = true;
        e.preventDefault();
        daRenderResult(
          checkDeliveryAvailability(DA_SETTINGS, getDAProdId(), daGetCookie("da_lastzipcode")),
          daGetCookie("da_lastzipcode")
        );
        modal.open();
      });

      // CONTINUE SHOPPING (available state) -> resumes any paused add-to-cart action
      jQuery("body").on("click", "#da_pop_close", function () {
        completePendingDAAction();
        modal.close();
      });

      // CLOSE (not-available state) -> just dismiss, nothing to resume
      jQuery("body").on("click", "#da_pop_close_unavailable", function () {
        pendingDAAction = null;
        modal.close();
      });

      // change pincode link
      jQuery("body").on("click", ".da_diff_check", function (e) {
        e.preventDefault();
        jQuery("#da-available, #da-noavailable, .da_diff_check").hide();
        jQuery(".da_checker").show();
      });

      // ENTER key submits
      jQuery(".da_popup").on("keypress", "#da_zincode", function (e) {
        var code = e.which ? e.which : e.keyCode;
        if (code === 13) jQuery("#da_check_zincode").click();
      });

      checkPeriodicAndAddDA();
    });

    jQuery("body").on("click", "#da_check_zincode", function () {
      var zipCode = jQuery("#da_zincode").val().trim();
      var indianPincodeRegex = /^[1-9][0-9]{5}$/;

      if (!zipCode) {
        jQuery("#da-error-msg").html("Input cannot be empty");
      } else if (!indianPincodeRegex.test(zipCode)) {
        jQuery("#da-error-msg").html("Please enter a valid 6-digit pincode");
      } else {
        daSetCookie("da_lastzipcode", zipCode);
        var idToCheck = (pendingDAAction && pendingDAAction.checkId != null)
          ? pendingDAAction.checkId
          : getDAProdId();
        daRenderResult(checkDeliveryAvailability(DA_SETTINGS, idToCheck, zipCode), zipCode);
        jQuery("#da-error-msg").html("");
      }
    });

    function daRenderResult(isAvailable, zipcode) {
      if (zipcode === "") {
        jQuery(".da_popup .da_checker").show();
        return;
      }
      jQuery(".da_popup .zincode_cookie, .da-zipcode-info").html(zipcode);
      jQuery(".da_popup .da_checker").hide();
      if (isAvailable) {
        jQuery("#da-noavailable").hide();
        jQuery("#da-available").show();
        jQuery("#da_pop_close").show();
      } else {
        jQuery("#da-available").hide();
        jQuery("#da-noavailable").show();
        jQuery("#da_pop_close_unavailable").show();
        // Item isn't deliverable here, so there's nothing to resume.
        pendingDAAction = null;
      }
      jQuery(".da_diff_check").show();
    }

    jQuery("body").on(
      "click",
    "form[action*='cart/add'] button[type='submit'], " +
    "[data-shopify='payment-buttons'] button, " +
    "button[type='submit'][name='add'], " +
    "button[type='button'].quick-add-btn, " +
    "button[type='button'].product-card__list-atc, " +
    "button.variant-modal_add.model_select_varint",
      function (e) {
        if (daBypassGuard) return;
        isHeaderDACheck = false;
        daValidateZip(e, jQuery(this));
      }
    );

    function daValidateZip(e, $el) {
      var form = $el.closest('form[action*="cart/add"]');
      var $variantRow = $el.closest(".variant-item-wrapper");
      var productId, variantId;

      if (form.length) {
        productId = form.find('input[name="product-id"]').val();
        variantId = form.find('input[name="id"]').val();
      } else if ($variantRow.length) {
        variantId = $variantRow.data("variant-id");
        productId = $el.closest(".wrapper-modal-jtpl").find("[data-attr]").data("attr");
      }

      var checkId = productId || variantId || getDAProdId();

      var allowed = daGuard(checkId, function () {
        daBypassGuard = true;
        $el.trigger("click");
        daBypassGuard = false;
      });

      if (!allowed) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      return true;
    }

    function completePendingDAAction() {
      var action = pendingDAAction;
      pendingDAAction = null;
      if (action && typeof action.resume === "function") {
        action.resume();
      }
    }

    var DACartCheckCount = 0;
    function checkPeriodicAndAddDA() {
      jQuery("[type='submit'][name='checkout']").off("click.da").on("click.da", function (e) {
        refreshCartAvailability(function () {
          if (daGetCookie("da_lastzipcode") === "") {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (modal) modal.open();
          } else if (!isCheckoutAllowed) {
            e.preventDefault();
            e.stopImmediatePropagation();
            daRenderResult(false, daGetCookie("da_lastzipcode"));
            if (modal) modal.open();
          }
        });
      });

      DACartCheckCount++;
      if (jQuery("[type='submit'][name='checkout']").length <= 0 && DACartCheckCount < 2400) {
        setTimeout(checkPeriodicAndAddDA, 950);
      }
    }

    function refreshCartAvailability(callback) {
      if (DA_SETTINGS.applyFor === "specific") {
        jQuery.getJSON("/cart.js", function (cart) {
          isCheckoutAllowed = true;
          for (var i = 0; i < cart.items.length; i++) {
            if (!checkDeliveryAvailability(DA_SETTINGS, cart.items[i].product_id, daGetCookie("da_lastzipcode"))) {
              isCheckoutAllowed = false;
              break;
            }
          }
          if (callback) callback();
        });
      } else {
        isCheckoutAllowed = checkDeliveryAvailability(DA_SETTINGS, "", daGetCookie("da_lastzipcode"));
        if (callback) callback();
      }
    }

    window.DeliveryAvailability = {
      check: function (productId, zipcode) {
        return checkDeliveryAvailability(DA_SETTINGS, productId, zipcode);
      },
      getLastZipcode: function () {
        return daGetCookie("da_lastzipcode");
      },
      setZipcode: function (zip) {
        daSetCookie("da_lastzipcode", zip);
      },
      openPopup: function () {
        if (modal) modal.open();
      },
      // Global guard usable from any file (card.js, etc). Returns true if
      // the action can proceed immediately; returns false and resumes
      // `onAllowed` later once a deliverable pincode is confirmed.
      guard: function (productId, onAllowed) {
        return daGuard(productId, onAllowed);
      }
    };
  }
})();